import React from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { FileQuestion, ArrowRight } from "lucide-react";

export default function NotFoundPage() {
    return (
        <PublicLayout>
            <Seo title="Seite nicht gefunden | Bewerbung24.ai" description="Diese Seite existiert nicht. Erstelle stattdessen deine Bewerbung mit KI." path="/404" />
            <section className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="not-found-page">
                <FileQuestion size={56} className="mx-auto text-slate-300" />
                <h1 className="font-heading text-4xl font-bold text-slate-900 mt-6">Seite nicht gefunden</h1>
                <p className="text-slate-600 mt-3">Die gesuchte Seite existiert nicht (mehr). Vielleicht hilft dir eine dieser Seiten weiter:</p>
                <div className="mt-8 flex flex-wrap gap-2 justify-center">
                    {[["/", "Startseite"], ["/lebenslauf-erstellen", "Lebenslauf erstellen"], ["/bewerbung-erstellen", "Bewerbung erstellen"], ["/ratgeber", "Ratgeber"], ["/preise", "Preise"]].map(([to, label]) => (
                        <Link key={to} to={to} className="px-4 py-2 rounded-full text-sm font-semibold bg-white border border-slate-200 hover:border-red-300 text-slate-700">{label}</Link>
                    ))}
                </div>
                <Link to="/registrieren" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold text-sm btn-primary-grad">
                    Kostenlos Bewerbung erstellen <ArrowRight size={15} />
                </Link>
            </section>
        </PublicLayout>
    );
}
